import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Stack, TextAlpha } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { getLoginError } from '../../../util/LoginUtil';
import { LoginForm } from '../../login-form/LoginForm';
export const Login = ({ login, registrationLink, onAuthResetForm, onEmailChange }) => {
    var _a;
    const { t } = useTranslation([
        I18N_NAMESPACES.account,
        I18N_NAMESPACES.checkout,
        I18N_NAMESPACES.general,
        I18N_NAMESPACES.navigation,
    ]);
    useEffect(() => {
        onAuthResetForm();
    }, []);
    return (_jsx("div", { "data-analytics-bannerid": "header-account-login", children: _jsxs(Stack, { direction: "col", gap: "2", children: [_jsx(LoginForm, { onSubmit: login.onSubmit, action: login.action, forgotPasswordClicked: login.forgotPasswordClicked, errorFeedback: getLoginError((_a = login.errorFeedback) !== null && _a !== void 0 ? _a : '', t), initialEmail: login.initialEmail, loading: login.loading, onEmailChange: onEmailChange }), registrationLink && (_jsxs(Stack, { gap: "1", children: [_jsx(TextAlpha, { variant: "bodyM", color: "neutral", children: t(`${I18N_NAMESPACES.account}:account.navigation.registration.cta.text`) }), _jsx(Link, { href: registrationLink, testId: "register_link", theme: "branded", variant: "secondary", size: "md", children: t(`${I18N_NAMESPACES.account}:account.navigation.registration.cta.link`) })] }))] }) }));
};
